<template>
    <div class="content">
        <header-components activeClass="content"></header-components>
        <header-components-mobile></header-components-mobile>
        <section class="section section-two-side push-top">
            <div class="container">
                <div class="block">
                    <div class="row">
                        <div class="column side"></div>
                        <div class="column middle">
                            <h2>
                                KEBIJAKAN PRIVASI (PRIVACY POLICY) &ndash; SAFIRA SCOLA
                            </h2>
                            <h4>
                                Last updated September 2026
                            </h4><br>
                            <h3>1. Pendahuluan</h3>
                            <p>
                                Safira Scola ("kami") berkomitmen untuk melindungi dan menghormati
                                privasi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami
                                mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda saat
                                Anda menggunakan aplikasi dan layanan kami.
                            </p>
                            <h3>2. Informasi yang Kami Kumpulkan</h3>
                            <p>
                                Kami dapat mengumpulkan dan memproses jenis data berikut saat Anda
                                menggunakan aplikasi Safira Scola:
                            </p>
                            <ul>
                                <li>
                                    <strong>Informasi Akun Google:</strong> Alamat email, nama, dan foto
                                    profil yang diperoleh saat Anda melakukan otentikasi melalui Google
                                    OAuth.
                                </li>
                                <li>
                                    <strong>Data Layanan Google (jika diizinkan):</strong> Informasi dari
                                    Google Drive atau layanan terkait yang Anda berikan izinnya secara
                                    eksplisit untuk mendukung fungsi utama aplikasi.
                                </li>
                            </ul>
                            <h3>3. Penggunaan Informasi</h3>
                            <p>
                                Informasi yang kami kumpulkan digunakan semata-mata untuk:
                            </p>
                            <ul>
                                <li>
                                    Memverifikasi identitas pengguna dan menyediakan akses ke fitur
                                    aplikasi.
                                </li>
                                <li>
                                    Memproses dan menyinkronkan data sesuai dengan fungsi aplikasi.
                                </li>
                                <li>
                                    Memberikan dukungan pengguna dan pemberitahuan terkait pembaruan
                                    layanan.
                                </li>
                            </ul>
                            <h3>4. Keamanan dan Perlindungan Data</h3>
                            <p>
                                Kami menerapkan langkah-langkah keamanan teknis dan organisasi yang
                                sesuai untuk mencegah akses, pengubahan, pengungkapan, atau penghancuran
                                yang tidak sah atas data pribadi Anda.
                            </p>
                            <h3>5. Pembagian Data kepada Pihak Ketiga</h3>
                            <p>
                                Kami tidak menjual, menyewakan, atau memperdagangkan data pribadi Anda
                                kepada pihak ketiga mana pun. Data hanya dibagikan jika diwajibkan oleh
                                hukum atau untuk penyediaan layanan dasar yang Anda minta.
                            </p>
                            <h3>6. Hak Pengguna &amp; Penghentian Akses</h3>
                            <p>
                                Anda memiliki hak untuk mengakses, memperbarui, atau meminta penghapusan
                                data Anda. Anda juga dapat mencabut izin akses OAuth Safira Scola kapan
                                saja melalui menu Setelan Keamanan Akun Google.
                            </p>
                            <h3>7. Hubungi Kami</h3>
                            <p>
                                Jika Anda memiliki pertanyaan atau kekhawatiran tentang Kebijakan Privasi
                                ini, Anda dapat menghubungi kami melalui email di:
                                <a href="mailto:erickbudi.kurniawan@gmail.com">erickbudi.kurniawan@gmail.com</a>
                            </p>
                        </div>
                        <div class="column side"></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import HeaderMobile from '@/components/HeaderMobile.vue'
    import lozad from 'lozad'
    export default {
        name: 'privacy-policy',
        components: {
            'header-components': Header,
            'header-components-mobile': HeaderMobile,
        },
        metaInfo: {
            title: 'Privacy Policy',
            titleTemplate: '%s - Scola LMS | Tingkatkan Pembelajaran Di Sekolah Anda'
        },
        mounted() {
            const observer = lozad();
            observer.observe();
        }
    }
</script>